<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3 pt-5>
        <h1 class="title font-weight-bold">Step by Step accident help</h1>
        <p class="subheading pt-2">In the event of a crash, follow these steps.</p>
        <v-timeline dense clipped>
          <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            fill-dot
            class="white--text"
            color="secondary"
            white
          >
            <template v-slot:icon>
              <span>{{i+1}}</span>
            </template>
            <p class="primary--text" v-html="item.text"></p>
            <add-document v-if="i === 2" label="Add picture"></add-document>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import AddDocument from '@/components/AddDocument'

export default {
  components: {
    AddDocument
  },
  data: () => ({
    items: [
      {
        text: '<p>Move car to safe location and put hazards on if possible.</p>'
      },
      {
        text:
          '<p>Get registration for other party so their insurance can be contacted.</p>'
      },
      {
        text: '<p>Get their insurance information if available.</p>'
      },
      {
        text: '<p>Take details of any witnesses to the accident.</p>'
      },
      {
        text: '<p>Take pics at the scene of the accident for your evidence.</p>'
      },
      {
        text: '<p>Contact police if necessary.</p>'
      },
      {
        text: '<p>CALL G4Claims so you don’t have to pay your excess.</p>'
      }
    ]
  })
}
</script>
